<div class="trending-game">
  <div class="trending-game__img-block">
    <img (click)="showPopup.emit($event)" class="circle_img" alt="game-image" src="{{gameImg}}" />
  </div>
  <div class="trending-game__desc-block">
    <div class="trending-game__desc-block__header">
      <h1>Rank {{rank}}</h1>
      @if (!expanded) {
        <ion-icon src="../../../assets/images/trending_down.svg" (click)="expanded = !expanded">
        </ion-icon>
      }
      @if (expanded) {
        <ion-icon src="../../../assets/images/trending_up.svg" (click)="expanded = !expanded"
        class="up-arrow"></ion-icon>
      }
    </div>
    <div class="trending-game__desc-block__description">
      <h6>{{info | slice : 0 : 20}}...</h6>
    </div>
  </div>
</div>